import { SeniorityWithMemberCountResponse } from '../types/response/seniority-with-member-count-response';
import { Seniority } from '../types/seniority';

/**
 * Maps API response DTO to domain model
 */
export const mapSeniorityFromDTO = (dto: SeniorityWithMemberCountResponse): Seniority => ({
  id: dto.id,
  name: dto.name,
  memberCount: dto.memberCount,
});

/**
 * Maps array of API response DTOs to domain models
 */
export const mapSenioritiesFromDTO = (dtos: SeniorityWithMemberCountResponse[]): Seniority[] =>
  dtos.map(mapSeniorityFromDTO);
